import * as actionTypes from './actionTypes';

const initialState = {
  walletSummary: null,
  isLoading: false,
  error: null,
};

export const actions = {
  getWalletV3Summary: () => ({
    type: actionTypes.GET_WALLET_V3_SUMMARY_REQ,
  }),
  getWalletV3SummarySuccess: (payload) => ({
    type: actionTypes.GET_WALLET_V3_SUMMARY_SUCCESS,
    payload,
  }),
  getWalletV3SummaryFail: (error) => ({
    type: actionTypes.GET_WALLET_V3_SUMMARY_FAIL,
    error,
  }),
  setWalletV3Loading: (value) => ({
    type: actionTypes.SET_WALLET_V3_LOADING,
    value,
  }),
  clearWalletV3Summary: () => ({
    type: actionTypes.CLEAR_WALLET_V3_SUMMARY,
  }),
};

const walletV3Reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_WALLET_V3_SUMMARY_REQ:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.GET_WALLET_V3_SUMMARY_SUCCESS:
      return {
        ...state,
        walletSummary: action.payload,
        isLoading: false,
        error: null,
      };
    case actionTypes.GET_WALLET_V3_SUMMARY_FAIL:
      return {
        ...state,
        walletSummary: null,
        isLoading: false,
        error: action.error,
      };
    case actionTypes.SET_WALLET_V3_LOADING:
      return {
        ...state,
        isLoading: action.value,
      };
    case actionTypes.CLEAR_WALLET_V3_SUMMARY:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

walletV3Reducer.initialState = initialState;
export default walletV3Reducer;
